module.exports = __webpack_public_path__ + "static/img/2_1_3.7ef897a1.jpg";